import { render, staticRenderFns } from "./ent-tag-distribution-table.vue?vue&type=template&id=0c23d6e7&"
import script from "./ent-tag-distribution-table.vue?vue&type=script&lang=js&"
export * from "./ent-tag-distribution-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ent-tag-distribution-table.vue"
export default component.exports